import { registerLocale } from "react-datepicker";
import es from "date-fns/locale/es";
import { Formik, Form, Field, ErrorMessage } from "formik";
import Modal from "react-bootstrap/Modal";
import "./formularioAdministradores.scss";
import { memo, useState } from "react";
import React, { useEffect } from "react";
import SubTituloResMini from "../../../atoms/subTitles/SubTituloResMini";
import { SpinnerCircle } from "../../../atoms/spinner/Spinner";
import { actualizarAdmin, insertarAdmin } from "../../../services/AdminService";

registerLocale("es", es);

const FormularioAdmnistradores = (object) => {
  const [disableGuardar, setDisableGuardar] = useState(false);
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState({
    mensaje: false,
  });
  const [datos, setDatos] = useState({
    nombreadministrador: "",
    primerapellidoadministrador: "",
    segundoapellidoadministrador: "",
    nombreusuarioadministrador: "",
    passwordadministrador: "",
  });

  useEffect(() => {
    if (object.usuario !== undefined) {
      setDatos(object.usuario);
     
      setLoading(true);
    } else {
      setLoading(true);
    }
  }, [datos, object.usuario]);

  function formularioAdmnistradores() {
    return (
      <Modal
        className="infModal fechas"
        show={object.show}
        onHide={object.handleClose}
        backdrop="static"
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {/* <Titulo
              titulo={`${
                object.usuario !== undefined ? "Editar" : "Nuevo"
              } Administrador`}
              tipo={"tituloModal"}
            /> */}
            <h4 className="tituloModal">{object.usuario !== undefined ? "Editar Administrador" : "Nuevo Administrador"
          }</h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="caja_formulario col-xxl-12 col-xl-12 col-lg-12 cold-md-12 cold-sm-12">
            {loading ? (
              <>
                <Formik
                  initialValues={{
                    nombreadministrador:
                      datos?.nombreadministrador === ""
                        ? ""
                        : datos?.nombreadministrador,
                    primerapellidoadministrador:
                      datos?.primerapellidoadministrador === ""
                        ? ""
                        : datos?.primerapellidoadministrador,
                    segundoapellidoadministrador:
                      datos?.segundoapellidoadministrador === ""
                        ? ""
                        : datos?.segundoapellidoadministrador,
                    nombreusuarioadministrador:
                      datos?.nombreusuarioadministrador === ""
                        ? ""
                        : datos?.nombreusuarioadministrador,
                    passwordadministrador:
                      datos?.passwordadministrador === ""
                        ? ""
                        : datos?.passwordadministrador,
                    repetirPassword: "",
                  }}
                  validate={(valores) => {
                    const errores = {};
                   
                    if (
                      valores.nombreadministrador === null ||
                      valores.nombreadministrador === ""
                    ) {
                      errores.nombreadministrador = "Debe escribir un nombre.";
                    }
                    if (
                      valores.primerapellidoadministrador === null ||
                      valores.primerapellidoadministrador === ""
                    ) {
                      errores.primerapellidoadministrador =
                        "Debe escribir un primer apellido.";
                    }
                    if (
                      valores.segundoapellidoadministrador === null ||
                      valores.segundoapellidoadministrador === ""
                    ) {
                      errores.segundoapellidoadministrador =
                        "Debe escribir un segundo apellido.";
                    }
                    if (
                      valores.nombreusuarioadministrador === null ||
                      valores.nombreusuarioadministrador === ""
                    ) {
                      errores.nombreusuarioadministrador =
                        "Debe escribir un nombre de usuario.";
                    }
                    if (
                      valores.passwordadministrador === null ||
                      valores.passwordadministrador === ""
                    ) {
                      errores.passwordadministrador =
                        "Debe escribir una contraseña.";
                    } else if (
                      valores.passwordadministrador !== valores.repetirPassword
                    ) {
                      errores.passwordadministrador =
                        "Las dos contraseñan deben coincidir.";
                    }
                    if (
                      valores.repetirPassword === null ||
                      valores.repetirPassword === ""
                    ) {
                      errores.repetirPassword = "Debe escribir una contraseña.";
                    } else if (
                      valores.repetirPassword !== valores.passwordadministrador
                    ) {
                      errores.repetirPassword =
                        "Las dos contraseñan deben coincidir.";
                    }
                    setDisableGuardar(true);
                    return errores;
                  }}
                  onSubmit={(valores, { resetForm }) => {
                    const errors = {};

                    valores.nombreadministrador =
                      valores.nombreadministrador.toUpperCase();
                    valores.primerapellidoadministrador =
                      valores.primerapellidoadministrador.toUpperCase();
                    valores.segundoapellidoadministrador =
                      valores.segundoapellidoadministrador.toUpperCase();
                    valores.luserbd = "N";
                    if (Object.keys(errors).length === 0) {
                     
                      if (object.usuario !== undefined) {
                        
                        valores.idadministrador = datos.idadministrador;
                        actualizarAdmin(valores.idadministrador, valores).then(
                          (data) => {
                            
                            setShow({
                              error: false,
                              respuesta: true,
                              respuestaTexto: data.data,
                            });
                          }
                        );
                      } else {
                        
                        insertarAdmin(valores).then((data) => {
                          setShow({
                            error: false,
                            respuesta: true,
                            respuestaTexto: data,
                          });
                          resetForm();
                        });
                      }
                    }
                  }}
                >
                  {({ errors }) => (
                    <>
                      <Form>
                        <div className="container">
                          <div className="row">
                            <div className="row col-xxl-12 col-xl-12 col-lg-12 cold-md-12 cold-sm-12 pb-2">
                              {show.error ? (
                                <div className="errorMesage rojo fs-4">
                                  Es necesario completar los datos obligatorios.
                                </div>
                              ) : null}

                              {show.respuesta ? (
                                <div className="errorMesage verde fs-4">
                                  {show.respuestaTexto}
                                </div>
                              ) : null}
                              <label htmlFor="nom">
                                <SubTituloResMini nombre="Nombre (*)"></SubTituloResMini>
                              </label>
                              <Field
                                type="text"
                                id="nom"
                                name="nombreadministrador"
                                className="form-control inputUppercase"
                                placeholder="Nombre"
                              />
                              <ErrorMessage
                                name="nombreadministrador"
                                component={() => (
                                  <div className="error rojo pt-2">
                                    {errors.nombreadministrador}
                                  </div>
                                )}
                              />
                            </div>
                            <div className="row col-xxl-12 col-xl-12 col-lg-12 cold-md-12 cold-sm-12 pb-2">
                              <label htmlFor="primerApe">
                                <SubTituloResMini nombre="Primer Apellido (*)"></SubTituloResMini>
                              </label>
                              <Field
                                type="text"
                                id="primerApe"
                                name="primerapellidoadministrador"
                                className="form-control inputUppercase"
                                placeholder="Primer Apellido"
                              />
                              <ErrorMessage
                                name="primerapellidoadministrador"
                                component={() => (
                                  <div className="error rojo pt-2">
                                    {errors.primerapellidoadministrador}
                                  </div>
                                )}
                              />
                            </div>
                            <div className="row col-xxl-12 col-xl-12 col-lg-12 cold-md-12 cold-sm-12 pb-2">
                              <label htmlFor="segundoApe">
                                <SubTituloResMini nombre="Segundo Apellido (*)"></SubTituloResMini>
                              </label>
                              <Field
                                type="text"
                                id="segundoApe"
                                name="segundoapellidoadministrador"
                                className="form-control inputUppercase"
                                placeholder="Segundo Apellido"
                              />
                              <ErrorMessage
                                name="segundoapellidoadministrador"
                                component={() => (
                                  <div className="error rojo pt-2">
                                    {errors.segundoapellidoadministrador}
                                  </div>
                                )}
                              />
                            </div>
                            <div className="row col-xxl-12 col-xl-12 col-lg-12 cold-md-12 cold-sm-12 pb-2">
                              <label htmlFor="nombreUsu">
                                <SubTituloResMini nombre="Nombre Usuario (*)"></SubTituloResMini>
                              </label>
                              <Field
                                type="text"
                                id="nombreUsu"
                                name="nombreusuarioadministrador"
                                className="form-control"
                                placeholder="Nombre Usuario"
                              />
                              <ErrorMessage
                                name="nombreusuarioadministrador"
                                component={() => (
                                  <div className="error rojo pt-2">
                                    {errors.nombreusuarioadministrador}
                                  </div>
                                )}
                              />
                            </div>
                            <div className="row col-xxl-12 col-xl-12 col-lg-12 cold-md-12 cold-sm-12 pb-2">
                              <label htmlFor="pass">
                                <SubTituloResMini nombre="Contraseña (*)"></SubTituloResMini>
                              </label>
                              <Field
                                type="password"
                                id="pass"
                                name="passwordadministrador"
                                className="form-control"
                                placeholder="Contraseña"
                              />
                              <ErrorMessage
                                name="passwordadministrador"
                                component={() => (
                                  <div className="error rojo pt-2">
                                    {errors.passwordadministrador}
                                  </div>
                                )}
                              />
                            </div>
                            <div className="row col-xxl-12 col-xl-12 col-lg-12 cold-md-12 cold-sm-12 pb-2">
                              <label htmlFor="repetirPass">
                                <SubTituloResMini nombre="Repetir Contraseña (*)"></SubTituloResMini>
                              </label>
                              <Field
                                type="password"
                                id="repetirPass"
                                name="repetirPassword"
                                className="form-control"
                                placeholder="Repetir Contraseña"
                              />
                              <ErrorMessage
                                name="repetirPassword"
                                component={() => (
                                  <div className="error rojo pt-2">
                                    {errors.repetirPassword}
                                  </div>
                                )}
                              />
                            </div>

                            <div className="d-flex mb-2 flex-sm-row flex-column">
                              <button
                                id="grabarAnexoii1"
                                className="btn m-2"
                                type="submit"
                                onClick={
                                  Object.keys(errors).length === 0
                                    ? null
                                    : () => {
                                        setShow({
                                          error: true,
                                        });

                                        
                                      }
                                }
                                disabled={
                                  // borrador === false && !disablePresentar
                                  !disableGuardar
                                }
                              >
                                <i className="fa-solid fa-save"></i>{" "}
                                {object.usuario !== undefined
                                  ? "Guardar"
                                  : "Crear"}{" "}
                                Administrador
                              </button>
                            </div>
                          </div>
                        </div>
                      </Form>
                    </>
                  )}
                </Formik>
              </>
            ) : (
              <SpinnerCircle></SpinnerCircle>
            )}
          </div>
        </Modal.Body>
      </Modal>
    );
  }

  return <>{formularioAdmnistradores()}</>;
};

export default memo(FormularioAdmnistradores);
